import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import SmoothScroll from "@/components/SmoothScroll";
import ParticleField from "@/components/ParticleField";
import DataRail from "@/components/DataRail";
import LiveHUD from "@/components/LiveHUD";

function App() {
  useEffect(() => {
    document.title = "OmniCoreTek — The Global Semiconductor & Component Exchange";
  }, []);

  return (
    <div className="App">
      <ParticleField />
      <div className="noise-overlay" />
      <SmoothScroll>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </SmoothScroll>
      <DataRail />
      <LiveHUD />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(10,17,36,0.9)",
            color: "#F8FAFC",
            border: "1px solid rgba(0,229,255,0.25)",
            backdropFilter: "blur(18px)",
          },
        }}
      />
    </div>
  );
}

export default App;
